export const DEMO_MESSAGES = [
  {
    "id": 1,
    "hour": "HOUR 1 - LIVE = EDGE",
    "title": "⚡ Live = Edge",
    "content": "Elite runs on direct NSE data. Zero delay, zero noise. Every tick, real time.",
    "tip": {
      "heading": "🎯 Experience the Difference:",
      "content": "Open any NIFTY chart and watch the live feed. No 15-minute delays. No stale data. Just pure, unfiltered market reality."
    },
    "subcontent": {
      "heading": "Your Edge:",
      "content": "While others trade on yesterday's news, you're seeing the market as it breathes. This isn't just data—it's your competitive advantage."
    },
    "action": "See Live Data"
  },
  {
    "id": 2,
    "hour": "HOUR 2 - WHO'S BEHIND THE MOVE",
    "title": "🎭 Know Who's Behind the Move",
    "content": "Don't just watch price—understand who's behind it. That's trading, not guessing.",
    "tip": {
      "heading": "🎯 See Beyond the Candles:",
      "content": "Elite reveals the players behind every move. Institutional buying? Retail panic? Smart money accumulation? You'll know before others even suspect."
    },
    "subcontent": {
      "heading": "Stop Guessing:",
      "content": "Every price movement has a story. Elite tells you who's writing it—institutions, retail traders, or algorithmic flows."
    },
    "action": "Identify the Players"
  },
  {
    "id": 3,
    "hour": "HOUR 3 - ORDER FLOW ADVANTAGE",
    "title": "📊 The Order Flow Advantage",
    "content": "Elite tracks institutional money in real time. See where the real weight is shifting.",
    "tip": {
      "heading": "🎯 Follow the Smart Money:",
      "content": "Watch the Delta and Volume Profile tools. When institutions move billions, Elite shows you exactly where that money flows—before the price reflects it."
    },
    "subcontent": {
      "heading": "Real-Time Intelligence:",
      "content": "Order flow doesn't lie. Price can be manipulated, but the flow of institutional money reveals true market direction."
    },
    "action": "Track Money Flow"
  },
  {
    "id": 4,
    "hour": "HOUR 4 - MARKET PROFILE + ORDER FLOW",
    "title": "🗺️ Market Profile + Order Flow",
    "content": "Profiles give you the map. Elite gives you the driver's seat.",
    "tip": {
      "heading": "🎯 Complete Market Vision:",
      "content": "Market Profile shows you where the market has been. Order Flow shows you where it's going. Together, they give you market omniscience."
    },
    "subcontent": {
      "heading": "Navigate with Precision:",
      "content": "Know not just support and resistance, but exactly how much institutional weight is behind each level."
    },
    "action": "See the Full Picture"
  },
  {
    "id": 5,
    "hour": "HOUR 5 - ELITE = ACCURACY",
    "title": "🎯 Elite = Accuracy",
    "content": "One IB/IS signal on live data can pay for your quarter. That's the power of Elite.",
    "tip": {
      "heading": "🎯 High-Probability Signals:",
      "content": "Elite's IB/IS (Initial Balance/Initial Support) signals on live data have the accuracy that turns single trades into quarterly profits."
    },
    "subcontent": {
      "heading": "ROI Reality:",
      "content": "Elite doesn't just give you data—it gives you signals so precise that one good trade can cover months of subscription costs."
    },
    "action": "See IB/IS Signals"
  },
  {
    "id": 6,
    "hour": "HOUR 6 - LIQUIDITY REVEALED",
    "title": "💧 Liquidity Revealed",
    "content": "Candles can't show it. Order Flow exposes hidden buyers and sellers instantly.",
    "tip": {
      "heading": "🎯 Hidden Market Depth:",
      "content": "See the iceberg orders, the hidden liquidity, the institutional accumulation happening below the surface. Elite makes the invisible visible."
    },
    "subcontent": {
      "heading": "Beyond Candlesticks:",
      "content": "Traditional charts show you what happened. Elite shows you what's happening and what's about to happen."
    },
    "action": "Uncover Hidden Liquidity"
  },
  {
    "id": 7,
    "hour": "HOUR 7 - 24 HOURS LEFT",
    "title": "⏰ 24 Hours Left",
    "content": "Your Elite demo is half over. Have you seen live Order Flow in action yet?",
    "tip": {
      "heading": "🎯 Don't Miss This:",
      "content": "You're halfway through your Elite experience. If you haven't explored Order Flow yet, you're missing the heart of what makes Elite revolutionary."
    },
    "subcontent": {
      "heading": "Time is Ticking:",
      "content": "Every hour you don't experience Order Flow is an hour you're not seeing what professional traders see every day."
    },
    "action": "Experience Order Flow"
  },
  {
    "id": 8,
    "hour": "HOUR 8 - UPGRADE YOUR TIMING",
    "title": "⚡ Upgrade Your Timing",
    "content": "95% of Elite traders say Order Flow sharpened their entries and exits immediately.",
    "tip": {
      "heading": "🎯 Precision Timing:",
      "content": "Don't just enter trades—enter them at the exact moment when Order Flow confirms institutional backing. Your timing will never be the same."
    },
    "subcontent": {
      "heading": "Proven Results:",
      "content": "Almost every Elite trader reports immediate improvement in entry and exit timing. You're about to join them."
    },
    "action": "Perfect Your Timing"
  },
  {
    "id": 9,
    "hour": "HOUR 9 - ELITE = CONTEXT + FLOW",
    "title": "🎯 Elite = Context + Flow",
    "content": "Market Profile shows where. Order Flow shows when. Elite gives you both.",
    "tip": {
      "heading": "🎯 Complete Trading Intelligence:",
      "content": "Context without timing is useless. Timing without context is gambling. Elite gives you both—the complete picture for perfect trades."
    },
    "subcontent": {
      "heading": "The Perfect Combination:",
      "content": "When you know where the market is likely to react AND when institutions are positioning, trading becomes strategic, not speculative."
    },
    "action": "See Context + Flow"
  },
  {
    "id": 10,
    "hour": "HOUR 10 - SCARCITY REMINDER",
    "title": "⚠️ Scarcity Reminder",
    "content": "Your 48-hour demo is ticking. Don't leave without seeing the difference Elite makes.",
    "tip": {
      "heading": "🎯 Final Hours:",
      "content": "You have less than 24 hours left to experience what professional traders use every day. Don't let this opportunity slip away."
    },
    "subcontent": {
      "heading": "Don't Walk Away Empty-Handed:",
      "content": "You've come this far. See what Elite can do for your trading before time runs out."
    },
    "action": "Maximize Your Demo"
  },
  {
    "id": 11,
    "hour": "HOUR 11 - INSTITUTIONAL FOOTPRINTS",
    "title": "👣 Institutional Footprints",
    "content": "Elite tools like Spectrum & Gamma show you where the writers are setting traps.",
    "tip": {
      "heading": "🎯 Advanced Options Intelligence:",
      "content": "Spectrum and Gamma analysis reveal where option writers are positioning. See the traps before you walk into them—or profit from them."
    },
    "subcontent": {
      "heading": "Institutional Transparency:",
      "content": "Options writers think they're invisible. Elite's advanced tools make their strategies crystal clear."
    },
    "action": "See Options Traps"
  },
  {
    "id": 12,
    "hour": "HOUR 12 - FINAL COUNTDOWN",
    "title": "🚨 Final Countdown",
    "content": "Your Elite demo ends today. Keep your edge alive—upgrade now.",
    "tip": {
      "heading": "🎯 Don't Lose Your Edge:",
      "content": "You've experienced trading with institutional-grade tools. Going back to basic charts after this would be like racing with a blindfold."
    },
    "subcontent": {
      "heading": "The Choice is Yours:",
      "content": "Continue with Elite's professional tools, or return to guessing. You know what professional traders choose."
    },
    "action": "Upgrade to Elite"
  }
]